import { isSupabaseConfigured, supabase } from "./supabase";
import { getFunctionsErrorDetails } from "./functionErrors";

export const contactService = {
  async sendMessage(payload) {
    if (!isSupabaseConfigured) {
      throw new Error("Contact form is not configured yet. Add your Supabase settings to .env.");
    }

    const { data, error } = await supabase.functions.invoke("send-contact-email", {
      body: payload,
    });

    if (error) {
      const details = await getFunctionsErrorDetails(error, "Unable to send message right now.");
      throw new Error(details);
    }

    if (!data?.success) {
      throw new Error(data?.message || "Unable to send message right now.");
    }

    return data;
  },
};
